<template>
  <font-awesome-icon :icon="`fa-regular ${icon}`" v-bind="$attrs" ></font-awesome-icon>
</template>

<script>
export default {
  props: ['icon']
}
</script>